import { catchError, of, switchMap, tap } from 'rxjs';

import { SessionStorageService } from './session-storage.service';
import { ConstantService, SessionStorage } from './constant.service';
import { CommonService } from './common.service';
import {
  AccessTokenValidationReq,
  AuthTokenReq_KYC,
  JWTTokenReq,
} from '../models/request.model';
import { UserSessionService } from './user-session.service';
import { UserSession } from '../models/response.model';
import { UtilService } from './util.service';
import { handleHttpError } from './handle-http-error.service';
import { EncryptionService } from './encryption.service';
import { TokenService } from './token.service';
import { environment } from '../../environments/environment';
import { clevertapPush } from '../services/modification-common.service';


export function initializeApp(
  tokenService: TokenService,
  commonService: CommonService,
  sessionStorageService: SessionStorageService,
  userSessionService: UserSessionService,
  utilService: UtilService,
  constantService: ConstantService,
  encryptionService : EncryptionService
): () => Promise<void> {
  
// debugger;
  
const queryParams = new URLSearchParams(window.location.search);
          
  sessionStorageService.setItem(SessionStorage.appSource, 'PWAWEB');

  try{
    const clientCode =  queryParams.get('ClientCode') || ''
    sessionStorageService.setItem(
      SessionStorage.clientCode,
      encryptionService.decryptUsingAES256(clientCode) ||
        sessionStorageService.getItem(SessionStorage.clientCode) ||
        ''
    );
  }catch(e){
    console.log(e)
  }

  sessionStorageService.setItem(
    SessionStorage.subSource,
    queryParams.get(SessionStorage.appSource)?.toUpperCase() ||
      sessionStorageService.getItem(SessionStorage.subSource) ||
      'PWAWEB'
  );
  
  

  sessionStorageService.setItem(
    SessionStorage.returnURL,
    queryParams.get(SessionStorage.returnURL) ||
      sessionStorageService.getItem(SessionStorage.returnURL) ||
    ''
  );

  try {
    sessionStorageService.setItem(
      'userID',
      queryParams.get('LoginID') ||
        sessionStorageService.getItem('userID') ||
        ''
    );
  } catch (e) {
    console.log(e);
  }
  // sessionStorageService.setItem(SessionStorage.appSource, 'PWAWEB');
  console.log('initializeApp');
  return (): Promise<void> => {
    return new Promise((resolve, reject) => {
      try {
        (window as any).segment_modification_func = (data: string) => {
          const result: string[] = data.split(',');
          console.log(result)
          // document.cookie = `${result[0]};Secure,path=/;domain=.5paisa.com;`;
          // document.cookie = `${result[1]};Secure,path=/;domain=.5paisa.com;`;
          sessionStorageService.setItem(
            SessionStorage.subSource,
            result[2]?.toUpperCase() ||
              sessionStorageService.getItem(SessionStorage.subSource) ||
              ''
          );
          const clientCode = encryptionService.decryptUsingAES256(result[result.length-1]);
          sessionStorageService.setItem(SessionStorage.clientCode,clientCode || '')          
        };
      } catch (e) {
        console.error('Error setting up reKyc_Func:', e);
      }
      // Initiating the first call (generateToken_KYC)
      tokenService
        .generateToken_KYC(sessionStorageService.getItem(SessionStorage.appSource) || '')
        .pipe(
          tap((response :any) => {
            // Storing the initial token in session storage
            console.log('Initial generateToken_KYC Response:', response);
            sessionStorageService.setItem(
              SessionStorage.authorization_KYC,
              response.data.token
            );
          }),

          // Switching to the next step after generating the token
          switchMap(() => {
            console.log('Fetching GeoLocation request...');
            return commonService.getGeoLocation().pipe(
              tap((response : any) => {
                console.log('Second Token Response:', response);
                if (response) {
                  constantService.geoLocation.latitude = response.latitude;
                  constantService.geoLocation.longitude = response.longitude;
                  constantService.geoLocation.country = response.country_name;
                  constantService.geoLocation.state_Prov = response.state_prov;
                  constantService.geoLocation.district = response.district;
                  constantService.geoLocation.city = response.city;
                  constantService.geoLocation.zipcode = response.zipcode;
                  constantService.geoLocation.ip = response.ip;
                  constantService.geoLocation.isp = response.isp;
                  sessionStorageService.setItem(SessionStorage.ip, response.ip);
                }
              })
            );
          }),
          switchMap(() => {
            console.log('Initial calling accessTokenValidation...');
            const accessToken: string = queryParams.get('AccessToken') || '';

             if (!accessToken) {
               console.log(
                 'AccessToken not provided, skipping accessTokenValidation.'
               );
               return of(null);
             }
            const encodedtoken = encodeURIComponent(accessToken);
            const AccessTokenValidationReq: AccessTokenValidationReq = {
              head: {
                appName: 'CommonAPI',
                osName: 'Web',
                appVersion: '1.0',
                clientIP:
                  sessionStorageService.getItem(SessionStorage.ip) || '::1',
              },
              body: {
                accessToken:
                  encodedtoken ||
                  sessionStorageService.getItem(SessionStorage.clientCode) ||
                  '',
              },
            };
            return tokenService
              .accessTokenValidation(AccessTokenValidationReq)
              .pipe(
                tap((response) => {
                  // Storing the second token in session storage
                  sessionStorageService.setItem(
                    SessionStorage.clientCode,
                    response.data?.ClientCode || ''
                  );
                }),
                catchError((error) => {
                  console.error('Error accessTokenValidation:', error);
                  const returnURL =
                    sessionStorageService.getItem(SessionStorage.returnURL) ||
                    'https://www.5paisa.com/';
                  window.location.href = returnURL;
                  return handleHttpError(error);
                })
              );
          }),
          switchMap(() => {
            
            if (userSessionService.getUserSessionData().clientCode) {
              return of(null);
            }
            console.log('Initial calling checkLoginResponse...');
            return tokenService.checkLoginResponse().pipe(
              tap((response) => {
                // Storing the second token in session storage
                
                if(  response.body?.ClientCode != '' && response.body?.ClientCode != null && response.body?.ClientCode != undefined ){
                  sessionStorageService.setItem(
                    SessionStorage.clientCode,
                    response.body?.ClientCode ||
                      sessionStorageService.getItem(SessionStorage.clientCode) ||sessionStorageService.getItem( SessionStorage.clientCode) ||
                      ''
                  );
                }else {
                  const returnURL =
                  sessionStorageService.getItem(SessionStorage.returnURL) ||
                  'https://www.5paisa.com/';
                  window.location.href = returnURL+environment.domainUrl;
                }
              
              }
            ),
              catchError((error) => {
                console.error('Error accessTokenValidation:', error);
                const returnURL =
                  sessionStorageService.getItem(SessionStorage.returnURL) ||
                  'https://www.5paisa.com/';
                window.location.href = returnURL;
                return handleHttpError(error);
              })
            );
          }),
          switchMap(() => {
            console.log('Initial auth_Token_KYC Response:');
            const request: AuthTokenReq_KYC = {
              appSource:
                sessionStorageService.getItem(SessionStorage.appSource) || '',
              mobile: '',
              clientCode:
                sessionStorageService.getItem(SessionStorage.clientCode) || '',
            };
            return tokenService.auth_Token_KYC(request).pipe(
              tap((response) => {
                console.log('Second Token Response:', response);

                sessionStorageService.setItem(
                  SessionStorage.authenticationkey_KYC,
                  response.data.token
                );
              }),
              catchError((error) => {
                console.error('Error fetching auth_Token_KYC:', error);
                const returnURL =
                  sessionStorageService.getItem(SessionStorage.returnURL) ||
                  'https://www.5paisa.com/';
                window.location.href = returnURL;
                return handleHttpError(error);
              })
            );
          }),
          // switchMap(() => {
          //   console.log('Initial jwtToken Response:');
          //   const clientCode = sessionStorageService.getItem(SessionStorage.clientCode) || '';
          //   const ip = sessionStorageService.getItem(SessionStorage.ip) || '';
          //   const appSource = sessionStorageService.getItem(SessionStorage.appSource) || '';

          //   const parameter = clientCode + appSource + ip + utilService.checkSumDate;
          //   const checkSumValue = utilService.GenerateCheckSum(appSource, parameter);

          //   const jwtTokenReq: JWTTokenReq = {
          //     head: {
          //       IPAddress:sessionStorageService.getItem(SessionStorage.ip) || '',
          //       AppSource:   sessionStorageService.getItem(SessionStorage.appSource) || '',
          //       ChecksumValue: checkSumValue
          //   },
          //   body: {
          //       clientcode: sessionStorageService.getItem(SessionStorage.clientCode) || '',
          //   }
          //   };
          //   return tokenService.JWTToken(jwtTokenReq).pipe(
          //     tap((response) => {
          //       console.log('Second Token Response:', response);
          //       localStorage.setItem(SessionStorage.authenticationkey_KYC, 'Bearer ' + response.data.body.Token);
          //     }),
          //     catchError((error) => {
          //       console.error('Error fetching auth_Token_KYC:', error);
          //       const returnURL =
          //         sessionStorageService.getItem(SessionStorage.returnURL) ||
          //         'https://www.5paisa.com/';
          //       // window.location.href = returnURL;
          //       return handleHttpError(error);
          //     })
          //   );
          // }),
        )
        .subscribe({
          next: (data) => {
            console.log('initializeApp resolved with data:', data);
            resolve();
          },
          error: (error) => {
            console.error('initializeApp rejected with error:', error);
            reject(error);
          },
        });
    });
  };
}